import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {UpdateActiveStep} from "../../../../redux/actions/tourActions";
import {STEPS} from "../../helpers";
import {Tour} from "antd";
import {history} from "../../../../utils/history";
import {ROUTERS_MAP} from "../../../../utils/routes";
import {useTourActions} from "../../hooks";
import './TourFiveStep.scss'
import YourPersonalAssistant from "../YourPersonalAssistant/YourPersonalAssistant";

const TourFiveStep = () => {
    const dispatch = useDispatch();
    const activeStep = useSelector((state) => state.tour?.activeStep);
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [step, setStep] = useState(0);
    const {handleClickNextStep5} = useTourActions();

    useEffect(() => {
        if ([STEPS.FIVE].includes(activeStep)) {
            setTimeout(() => {
                setIsOpen(true)
            }, 500)
        } else {
            setIsOpen(false)
        }
    }, [activeStep])

    const steps = [
        {
            title: t('tour_step_5'),
            description: <YourPersonalAssistant/>,
            target: () => document.querySelector(`.copilot__right-chat`),
            nextButtonProps: {
                children: <span>{t('next')}</span>,
                onClick: () => {
                    history.push(ROUTERS_MAP.AI_AGENTS);
                    setTimeout(() => {
                        setStep(1);
                    })
                }
            },
            placement: 'left'
        },
        {
            title: t('tour_step_5_1'),
            description: t('tour_step_5_1_desc'),
            target: () => document.querySelector('.chat-badge__container'),
            nextButtonProps: {
                children: <span>{t('next')}</span>,
                onClick: () => handleClickNextStep5()
            },
            placement: 'top'
        },
    ];

    return (
        <Tour
            rootClassName={`${(step === 1) ? 'tour-five-base' : ''}`}
            indicatorsRender={(current, total) => (
                <span>
                      {current + 1} / {total}
                     </span>
            )}
            placement="left"
            open={isOpen}
            current={step}
            onClose={() => {
                dispatch(UpdateActiveStep(null));
                setIsOpen(false)
                setStep(0)
            }}
            steps={steps}
            gap={{radius: 12, offset: 4 }}
        />
    );
};

export default TourFiveStep;